import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor, theme } from '@ezugi/ui/theme';

const { tints } = theme;
const SCROLLBAR_SIZE = 6;

const common = css`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const Container = styled.div`
  ${common};
  overflow: hidden;
`;

export const thumbCommon = css`
  box-sizing: border-box;
  border-radius: ${SCROLLBAR_SIZE / 2}px;
  background-color: rgba(0, 0, 0, ${tints.darker});
  border: 1px solid ${getThemeColor('foreground')};
  z-index: 501;
  opacity: ${tints.secondary};
`;

export const trackCommon = css`
  box-sizing: border-box;
  border-radius: ${SCROLLBAR_SIZE / 2}px;
  background-color: rgba(0, 0, 0, ${tints.dark});
  z-index: 500;
`;

export const vThumb = css`
  ${thumbCommon};
`;

export const vThumbStyle = {
  width: SCROLLBAR_SIZE,
  opacity: tints.secondary,
};

export const hThumb = css`
  ${thumbCommon};
`;

export const hThumbStyle = {
  height: SCROLLBAR_SIZE,
  opacity: tints.secondary,
};

export const vTrack = css`
  ${trackCommon};
  right: ${SCROLLBAR_SIZE}px;
  top: ${SCROLLBAR_SIZE}px;
  bottom: ${SCROLLBAR_SIZE}px;
`;

export const vTrackStyle = {
  width: SCROLLBAR_SIZE,
  height: 'auto',
  opacity: tints.secondary,
};

export const hTrack = css`
  ${trackCommon};
  bottom: ${SCROLLBAR_SIZE}px;
  left: ${SCROLLBAR_SIZE}px;
  right: ${SCROLLBAR_SIZE}px;
`;

export const hTrackStyle = {
  height: SCROLLBAR_SIZE,
  width: 'auto',
  opacity: tints.secondary,
};
